<div style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
  <button nz-button nzType="primary" (click)="toggleMonitorMode()">
    <i nz-icon nzType="desktop"></i>
    <span>Modo Monitor (TV)</span>
  </button>
</div>

@if (!isMonitorMode) {
<nz-row [nzGutter]="[24, 24]" [nzJustify]="'start'" class="options">
  @if (apiData) {
  @for (item of cards; track $index) {
  <nz-col [nzFlex]="'1'">
    <nz-card class="f-width nz-card-style clickable-card" (click)="handleCardClick(item)">
      <nz-row [nzGutter]="[8,8]" nzAlign="middle" nzJustify="space-between" class="f-height f-width">
        <nz-col nzSpan="auto">
          <h3><b>{{ item.name }}</b> <i nz-icon [nzType]="setConfigsAtCards(item).icon"
              [style.color]="setConfigsAtCards(item).color" style="margin-left: 10px; font-size:x-large "></i></h3>
        </nz-col>
      </nz-row>
      <nz-row>
        <nz-col nzSpan="auto">
          <h2><b>{{ item.register }}</b></h2>
        </nz-col>
      </nz-row>
    </nz-card>
  </nz-col>
  }
  }
</nz-row>

@if (apiData) {
<nz-row [nzGutter]="[24, 24]" [nzJustify]="'start'" class="options">
  <nz-col nzSpan="24" nzMd="12" nzLg="12">
    <nz-card [nzTitle]="barChartTitleTemplate" [nzBodyStyle]="{padding: '0px'}" class="f-height">
      <app-bar-items class="f-height"></app-bar-items>
    </nz-card>
  </nz-col>
  <nz-col nzSpan="24" nzMd="12" nzLg="12">
    <nz-card [nzBodyStyle]="{padding: '0px'}" class="f-height">
      <nz-row [nzGutter]="[8, 8]" nzAlign="middle" nzJustify="space-between" class="f-height f-width" style="padding: 24px 24px 0 24px;">
        <nz-col nzSpan="auto">
          <h3 style="margin: 0;"><b>Monitoramento de Transferências (Chassi)</b></h3>
        </nz-col>
        <nz-col>
          <button nz-button nzType="text" (click)="openExpandedChart('transfer')">
            <i nz-icon nzType="expand-alt"></i>
          </button>
        </nz-col>
      </nz-row>
      <app-transfer-table></app-transfer-table>
    </nz-card>
  </nz-col>
</nz-row>
}

<nz-row [nzGutter]="[24, 24]" [nzJustify]="'start'" class="options">
  <nz-col nzSpan="24" nzMd="12" nzLg="12">
    <nz-card [nzTitle]="lineChartTitleTemplate" [nzBodyStyle]="{padding: '0px'}" class="f-height">
      <app-line-items class="f-height"></app-line-items>
    </nz-card>
  </nz-col>
  <nz-col nzSpan="24" nzMd="12" nzLg="12">
    <nz-card [nzTitle]="maintenanceChartTitleTemplate" [nzBodyStyle]="{padding: '24px'}">
      <app-maintenance-chart [chassis]="maintenanceSelectedChassis"></app-maintenance-chart>
    </nz-card>
  </nz-col>
</nz-row>

<nz-row [nzGutter]="[24, 24]" [nzJustify]="'start'" class="options">
  <nz-col nzSpan="24">
    <nz-card [nzBodyStyle]="{padding: '0px'}">
      <nz-row [nzGutter]="[8, 8]" nzAlign="middle" nzJustify="space-between" class="f-height f-width" style="padding: 24px 24px 0 24px;">
        <nz-col nzSpan="auto">
          <h3 style="margin: 0;"><b>Status dos Veículos (Recorrência de Checklist)</b></h3>
        </nz-col>
        <nz-col>
          <button nz-button nzType="text" (click)="openExpandedChart('vehicle-status')">
            <i nz-icon nzType="expand-alt"></i>
          </button>
        </nz-col>
      </nz-row>
      <div style="padding: 16px 24px 24px 24px;">
        <app-vehicle-status-panel></app-vehicle-status-panel>
      </div>
    </nz-card>
  </nz-col>
</nz-row>

<nz-row [nzGutter]="[24, 24]" [nzJustify]="'start'" class="options">
  <nz-col nzSpan="24" nzMd="12" nzLg="12">
    <nz-card class="f-height">
      <nz-row [nzGutter]="[8, 8]" nzAlign="middle" nzJustify="space-between" class="f-height f-width">
        <nz-col nzSpan="auto">
          <h3><b>Check-lists por Usuários</b></h3>
        </nz-col>
      </nz-row>
      <app-table></app-table>
    </nz-card>
  </nz-col>
  <nz-col nzSpan="24" nzMd="12" nzLg="12">
    <nz-card [nzTitle]="titleTemplate" [nzBodyStyle]="{padding: '0px'}" class="f-height">
      <app-column-items class="f-height"></app-column-items>
    </nz-card>
  </nz-col>
</nz-row>

<ng-template #maintenanceChartTitleTemplate>
  <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
    <div style="display: flex; align-items: center; gap: 16px;">
      <h3 style="margin: 0;"><b>Análise de Manutenção (Últimos 6 meses)</b></h3>
      <button nz-button nzType="text" (click)="openExpandedChart('maintenance')">
        <i nz-icon nzType="expand-alt"></i>
      </button>
    </div>
    <nz-select 
      nzShowSearch 
      nzAllowClear 
      nzPlaceHolder="Filtrar por Veículo/Chassi" 
      [(ngModel)]="maintenanceSelectedChassis" 
      style="width: 250px;">
      <nz-option nzLabel="Todos os veículos (Frota Global)" [nzValue]="null"></nz-option>
      <nz-option *ngFor="let chassis of maintenanceChartComponent?.chassisList" [nzLabel]="chassis" [nzValue]="chassis"></nz-option>
    </nz-select>
  </div>
</ng-template>


<ng-template #titleTemplate>
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <h3 class="text-center" style="margin: 0; flex-grow: 1;"><b>Check-lists por Modelo</b></h3>
    <button nz-button nzType="text" (click)="openExpandedChart('model')">
      <i nz-icon nzType="expand-alt"></i>
    </button>
  </div>
</ng-template>

<ng-template #barChartTitleTemplate>
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <h3 class="text-center" style="margin: 0; flex-grow: 1;"><b>Check-lists por Mês</b></h3>
    <button nz-button nzType="text" (click)="openExpandedChart('month')">
      <i nz-icon nzType="expand-alt"></i>
    </button>
  </div>
</ng-template>

<ng-template #lineChartTitleTemplate>
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <h3 class="text-center" style="margin: 0; flex-grow: 1;"><b>Check-lists por Empresas</b></h3>
    <button nz-button nzType="text" (click)="openExpandedChart('company')">
      <i nz-icon nzType="expand-alt"></i>
    </button>
  </div>
</ng-template>

<nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" (nzOnCancel)="handleCancel()" [nzFooter]="null"
  [nzWidth]="'90%'">
  <ng-container *nzModalContent>
    <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
      @if (expandedChartType) {
      @switch (expandedChartType) {
      @case ('month') {
      <app-bar-items [limit]="12" [expanded]="true" style="width: 100%;"></app-bar-items>
      }
      @case ('model') {
      <app-column-items [limit]="12" [expanded]="true" style="width: 100%;"></app-column-items>
      }
      @case ('company') {
      <app-line-items [limit]="12" [expanded]="true" style="width: 100%;"></app-line-items>
      }
      @case ('transfer') {
      <app-transfer-table style="width: 100%;"></app-transfer-table>
      }
      @case ('maintenance') {
      <app-maintenance-chart [chassis]="maintenanceSelectedChassis" style="width: 100%; height: 500px;"></app-maintenance-chart>
      }
      @case ('vehicle-status') {
      <app-vehicle-status-panel style="width: 100%;"></app-vehicle-status-panel>
      }
      }
      } @else if (activeCardName) {
      <app-checklist-list-modal [cardName]="activeCardName" [initialFilters]="modalFilters" style="width: 100%;">
      </app-checklist-list-modal>
      } @else {
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;">
        <img src="assets/images/construction.png" alt="Em construção" style="max-width: 300px; margin-bottom: 20px;">
        <h3 style="text-align: center;">Estamos construindo isso, em breve será disponibilizado</h3>
      </div>
      }
    </div>
  </ng-container>
</nz-modal>
} @else {
  <!-- Layout de Monitor (TV) -->
  <div class="monitor-mode-container">
    <div class="monitor-header">
      <div style="display: flex; align-items: center; gap: 20px;">
        <h2>Painel de Monitoramento Suprema</h2>
        <div class="monitor-controls">
          <button nz-button nzType="text" (click)="togglePause()">
            <i nz-icon [nzType]="(isPaused) ? 'play-circle' : 'pause-circle'" style="font-size: 24px;"></i>
          </button>
          <div class="stage-indicators">
            @for (stage of [0, 1, 2, 3, 4, 5]; track stage) {
              <div 
                class="indicator-dot" 
                [class.active]="currentStage === stage"
                (click)="goToStage(stage)"
                nz-tooltip
                [nzTooltipTitle]="getStageName(stage)">
              </div>
            }
          </div>
        </div>
      </div>
      <button nz-button nzDanger (click)="toggleMonitorMode()">Sair do Monitor</button>
    </div>

    <div class="monitor-metrics">
      @for (item of cards; track $index) {
        <div class="metric-mini-card">
          <span class="label">{{ item.name }}</span>
          <span class="value" [style.color]="setConfigsAtCards(item).color">{{ item.register }}</span>
        </div>
      }
    </div>

    <div class="monitor-content">
      <!-- Slide 1: Gráficos Principais -->
      <div class="monitor-slide-grid" [hidden]="currentStage !== 0">
        <nz-card nzTitle="Check-lists por Mês">
          <app-bar-items [isMonitorMode]="true" class="f-height"></app-bar-items>
        </nz-card>
        <nz-card nzTitle="Check-lists por Empresas">
          <app-line-items [isMonitorMode]="true" class="f-height"></app-line-items>
        </nz-card>
      </div>

      <!-- Slide 2: Em Andamento (Exceto Manutenção) -->
      <div class="monitor-slide-full" [hidden]="currentStage !== 1">
        <nz-card nzTitle="Check-lists EM ANDAMENTO (Operacional)">
          <app-checklist-list-modal cardName="Operacional em Andamento" [isMonitorMode]="true" [initialFilters]="{status: ['in_progress'], type: ['new', 'used', 'transfer_start', 'transfer_done', 'vehicle']}"></app-checklist-list-modal>
        </nz-card>
      </div>

      <!-- Slide 3: Monitoramento de Transferências (Sozinho) -->
      <div class="monitor-slide-full" [hidden]="currentStage !== 2">
        <nz-card nzTitle="Monitoramento de Transferências (Chassi)" class="transfer-monitor-card">
          <app-transfer-table [isMonitorMode]="true"></app-transfer-table>
        </nz-card>
      </div>

      <!-- Slide 4: Status dos Veículos (Em Dia x Atrasados) -->
      <div class="monitor-slide-full" [hidden]="currentStage !== 3">
        <nz-card nzTitle="Status dos Veículos (Recorrência de Checklist)" class="transfer-monitor-card">
          <app-vehicle-status-panel [isMonitorMode]="true"></app-vehicle-status-panel>
        </nz-card>
      </div>

      <!-- Slide 5: Painel de Manutenção (Lista + Gráfico) -->
      <div class="monitor-slide-grid" [hidden]="currentStage !== 4">
        <nz-card nzTitle="Manutenções EM ANDAMENTO">
          <app-checklist-list-modal cardName="Manutenções Ativas" [isMonitorMode]="true" [initialFilters]="{status: ['in_progress'], type: ['maintenance']}"></app-checklist-list-modal>
        </nz-card>
        <nz-card nzTitle="Análise de Manutenção (Histórico)">
          <app-maintenance-chart [chassis]="null" class="f-height"></app-maintenance-chart>
        </nz-card>
      </div>

      <!-- Slide 6: Equipe e Modelos -->
      <div class="monitor-slide-grid" [hidden]="currentStage !== 5">
        <nz-card nzTitle="Check-lists por Usuários">
          <app-table [isMonitorMode]="true" class="f-height"></app-table>
        </nz-card>
        <nz-card nzTitle="Check-lists por Modelo">
          <app-column-items [isMonitorMode]="true" [limit]="12" class="f-height"></app-column-items>
        </nz-card>
      </div>
    </div>
  </div>
}